module.exports = __webpack_public_path__ + "img/RGPD-04.de46327c.svg";